import React, { useEffect, useState } from "react";
import logo from "../../assets/svg/Awesome events.svg";
import { Field, Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-multi-date-picker";
import type { Value } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/red.css";
import conatactImg from "../../assets/svg/enquiry/contactImg.svg";
import mailImg from "../../assets/svg/enquiry/mailImg.svg";
import linkedinImg from "../../assets/svg/enquiry/LinkedinImg.svg";
import { createEnquiryAPI, getEventByIDAPI, updateEnquiryAPI } from "../../services/EnquiriesServices/EnquiriesServices";
import CommonSnackbar from "../../components/common/toastMessage";
import { getIn } from "formik";
import { useLocation, useNavigate } from "react-router";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { statusMapping, statusOptions } from "../../utils/helperData";

interface Values {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  datePreference: any;
  salesStatus: string;
  // lostReason?: string;
  // websiteName: string;
  eventType: string;
  customEventType?: string;
  showEventDropdown?: boolean;
  eventDates: any;
  // eventStartTime: string;
  // eventEndTime: string;
  numberOfGuests: string;
  location: string;
  notes: string;
  budget: string;
  budgetType: string;
}
const eventTypes = [
  "Conference",
  "Wedding",
  "Party",
  "Charity Events",
  "Christmas Party",
  "Summer Party",
  "Award Dinner",
  "Gala Dinner",
  "Conferences",
  "Employee Engagement",
  "Fashion Shows",
  "Product Launch",
  "Incentive Travel",
  "Meeting",
  "Team Building",
  "Ticketed Event",
  "Others"
];


const InquiryForm = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    backgroundColor: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const enquiryId = location.state?.EnquiryId;
  // console.log(enquiryId, "enquiryId>?>>>");

  const inquiryFormDetails = [
    {
      name: "firstName",
      label: "First Name",
      required: true,
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "lastName",
      label: "Last Name",
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "email",
      label: "Email",
      required: true,
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      required: true,
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "companyName",
      label: "Company Name",
      required: true,
      colSpan: "col-span-2",
      types: "text",
    },
    // {
    //   name: "websiteName",
    //   label: "Website Name",
    //   required: true,
    //   colSpan: "col-span-2",
    //   types: "text",
    // },
    {
      name: "eventType",
      label: "Event Type",
      required: true,
      colSpan: "col-span-2",
      types: "select",
    },
    // {
    //   name: "salesStatus",
    //   label: "Status",
    //   required: true,
    //   colSpan: "col-span-2",
    //   types: "status",
    // },
    {
      name: "datePreference",
      label: "",
      required: true,
      colSpan: "col-span-2",
      types: "checkbox",
    },
    {
      name: "eventDates",
      label: "Event Date",
      required: true,
      colSpan: "col-span-2",
      types: "date",
    },
    // {
    //   name: "eventStartTime",
    //   label: "Event Time From",
    //   required: true,
    //   colSpan: "col-span-1",
    //   types: "time",
    // },
    // {
    //   name: "eventEndTime",
    //   label: "Event Time To",
    //   required: true,
    //   colSpan: "col-span-1",
    //   types: "time",
    // },
    {
      name: "numberOfGuests",
      label: "No of Guests",
      required: true,
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "location",
      label: "Location",
      required: true,
      colSpan: "col-span-1",
      types: "text",
    },
    {
      name: "notes",
      label: "Notes",
      // required: true,
      colSpan: "col-span-2",
      types: "textarea",
    },
    {
      name: "budgetType",
      label: "Budget Type",
      required: true,
      colSpan: "col-span-2",
      types: "budgetRadio",
    },
    {
      name: "budget",
      label: "Budget",
      required: true,
      colSpan: "col-span-2",
      types: "text",
    },
  ];

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .required('Please enter your first name')
      .min(3, 'First name must be at least 5 characters'),
    // lastName: Yup.string()
    //   .required('Please enter your last name')
    //   .min(1, 'Last name must be at least 1 character'),
    email: Yup.string()
      .email('Please enter a valid email address')
      .required('Email address is required'),
    phoneNumber: Yup.string()
      .required('Please enter your phone number'),
    // .matches(/^[0-9]{15}$/, 'Please enter a valid 10-digit phone number'),
    datePreference: Yup.array()
      .of(Yup.string())
      .min(1, "Please select your date preference")
      .max(1, "Please select only one date preference"),
    // websiteName: Yup.string()
    //   .required('Please enter your website name'),
    location: Yup.string()
      .required('Please enter your location'),
    companyName: Yup.string()
      .required('Please enter your company name')
      .min(5, 'Company name must be at least 5 characters'),
    // status: Yup.string()
    // .required('Please select status'),
    eventType: Yup.string()
      .required('Please select an event type'),
    eventDates: Yup.mixed().test(
      "eventDates-validation",
      function (value) {
        const { datePreference } = this.parent;
        const isSubmitting = this.options.context?.isSubmitting

        // No preference at all → show error
        // if (!Array.isArray(datePreference) || datePreference.length === 0) {
        //   return this.createError({ message: "Please select your date preference" });
        // }
        // Flexible / Multiple → must have >= 2 dates
              // If Fixed date preference is selected
      if (datePreference.includes("Fixed")) {
        // Check if value exists and is a valid date
        if (!value) {
          return this.createError({
            message: "Please select an event date"
          });
        }
      }
        if (
          datePreference.includes("Flexible") ||
          datePreference.includes("Multiple")
        ) {
          if (Array.isArray(value) && value.length >= 1) {
            return true;
          }
          return this.createError({
            message: "Please select at least two valid event dates",
          });
        }

        return true;
      }
    ),

    // eventStartTime: Yup.string()
    //   .required('Please select a start time'),
    // eventEndTime: Yup.string()
    //   .required('Please select an end time')
    //   .test('endTime', 'End time must be after start time',
    //     function (value) {
    //       return value > this.parent.eventStartTime;
    //     }),
    numberOfGuests: Yup.number()
      .typeError("Please enter a valid number")
      .required("Please enter the number of guests")
      .min(1, "Number of guests must be at least 1"),
    budgetType: Yup.string()
      .required('Please select budget type'),
    budget: Yup.number()
      .typeError("Please enter a valid number")
      .required("Budget is required")
      .min(0, "Budget must be a positive number"),
  });

  const [initialValues, setInitialValues] = useState<Values>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    datePreference: ["Fixed"],
    salesStatus: "NEW",
    // websiteName: "",
    eventType: "",
    customEventType: "",
    showEventDropdown: false,
    eventDates: "",
    // eventStartTime: "",
    // eventEndTime: "",
    numberOfGuests: "",
    location: "",
    notes: "",
    budget: "",
    budgetType: "Overall",
  });

  useEffect(() => {
    if (enquiryId) {
      fetchEnquiryData(enquiryId);
    }
  }, [enquiryId]);

  const fetchEnquiryData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getEventByIDAPI(id);
  
      // Transform API response → Formik shape
      // Create reverse mapping to convert API salesStatus to form status
      const reverseStatusMapping: { [key: string]: string } = {
        "new": "NEW",
        "contacted": "CONTACTED",
        "meeting": "MEETING",
        "proposal_sent": "PROPOSAL SENT",
        "site_visit": "SITE VISIT",
        "negotiating": "NEGOTIATING",
        "contract_sent": "CONTRACT SENT",
        "confirmed": "CONFIRMED",
        "lost": "LOST"
      };

      const enquiry = response?.data;
      const salesStatus = enquiry?.salesStatus || "NEW";
      const formStatus = reverseStatusMapping[salesStatus] || "NEW";

      setInitialValues({
        firstName: enquiry?.customerId?.firstName || "",
        lastName: enquiry?.customerId?.lastName || "",
        email: enquiry?.customerId?.email || "",
        phoneNumber: enquiry?.customerId?.phoneNumber || "",
        companyName: enquiry?.companyId?.companyName || "",
        datePreference: enquiry.datePreference?.length ? enquiry.datePreference : ["Fixed"],
        salesStatus: formStatus, // Use the mapped uppercase status
        // lostReason: enquiry.lostReason || ""
        eventType: enquiry.eventType || "",
        customEventType: enquiry.customEventType || "",
        showEventDropdown: false,
        eventDates: enquiry.eventDates?.length
          ? enquiry.eventDates.map((d: string) => new Date(d)) // for date picker
          : "",
        numberOfGuests: enquiry.numberOfGuests?.toString() || "",
        location: enquiry.location || "",
        notes: enquiry.notes || "",
        budget: enquiry.budget?.toString() || "",
        budgetType: enquiry.budgetPerPerson ? "Per person" : "Overall",
      });
    } catch (error) {
      console.error("Error fetching enquiry:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    // <div className="noScrollbar">
    <div className="">
      <div className="grid lg:grid-cols-2 gap-5 h-[95vh] rounded-[5px] overflow-scroll ">
        <div className="col-span-1 rounded-[5px] bg-white">
          <div>
            <img src={logo} alt="Logo" />
          </div>

          <Formik<Values>
            // initialValues={{
            //   firstName: "",
            //   lastName: "",
            //   email: "",
            //   phoneNumber: "",
            //   companyName: "",
            //   datePreference: ["Fixed"],
            //   // websiteName: "",
            //   eventType: "",
            //   customEventType: "",
            //   showEventDropdown: false,
            //   eventDates: "",
            //   // eventStartTime: "",
            //   // eventEndTime: "",
            //   numberOfGuests: "",
            //   location: "",
            //   notes: "",
            //   budget: "",
            //   budgetType: "Overall",
            // }}
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            validateOnMount={true}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={async (values, actions) => {
              // const start = new Date(
              //   `${values.eventDates}T${values.eventStartTime}:00`
              // ).toISOString();
              // const end = new Date(
              //   `${values.eventDates}T${values.eventEndTime}:00`
              // ).toISOString();
              const Status = statusMapping[values.salesStatus] || values.salesStatus.toLowerCase();
                          // Sort dates in ascending order
                const sortedEventDates = Array.isArray(values.eventDates)
                ? values.eventDates
                    .map((d: any) => {
                      if (typeof d === "string") return d;
                      return new Date(d);
                    })
                    .sort((a: any, b: any) => new Date(a).getTime() - new Date(b).getTime()) // Sort ascending
                    .map((d: any) => 
                      typeof d === "string" 
                        ? d 
                        : new Date(d).toISOString().split("T")[0] // format YYYY-MM-DD
                    )
                : values.eventDates
                  ? [new Date(values.eventDates).toISOString().split("T")[0]]
                  : [];
              const payload = {
                ...values,
                eventType: values.eventType === "Others" ? "Others" : values.eventType,
                eventDates: sortedEventDates, // Use sorted dates
                // eventStartTime: start,
                // eventEndTime: end,
                // ✅ dynamic budget flags
                salesStatus: Status,
                budgetPerPerson: values.budgetType === "Per person",
                budgetOverall: values.budgetType === "Overall",
                isPrimary: true,
              };

              try {
                if (enquiryId) {
                  // 🔹 Call update API
                  const response = await updateEnquiryAPI(enquiryId, payload);
                  if(response.status == 200) { 
                  setSnackbar({
                    open: true,
                    message: "Enquiry Updated Successfully",
                    backgroundColor: "green",
                  }); 
              
                 setTimeout(() => {
                  actions.resetForm();
                  navigate(-1);
                 }, 500); 
                }  else if(response.status == 400){
                  setSnackbar({
                    open: true,
                    message: response?.message,
                    backgroundColor: "red",
                  });
                } else {
                  setSnackbar({
                    open: true,
                    message: response?.message,
                    backgroundColor: "red",
                  });
                }
                } else {
                  // 🔹 Create new enquiry
                  const response = await createEnquiryAPI(payload);
                  if(response.status == 200){
                  setSnackbar({
                    open: true,
                    message: "Enquiry Created Successfully",
                    backgroundColor: "green",
                  });
                   
                    setTimeout(() => {
                      actions.resetForm();
                      navigate(-1);
                     }, 500);
                  } else if(response.status == 400){
                    setSnackbar({
                      open: true,
                      message: response?.message,
                      backgroundColor: "red",
                    });
                  }  else {
                    setSnackbar({
                      open: true,
                      message: response?.message,
                      backgroundColor: "red",
                    });
                  }
                }
               
              } catch (error) {
                console.error("Error:", error);
                setSnackbar({
                  open: true,
                  message: enquiryId ? "Error updating enquiry" : "Error creating enquiry",
                  backgroundColor: "red",
                });
              }
            }}
          >
            {({ errors, touched, handleChange, handleBlur, values, setFieldValue, setFieldTouched, isSubmitting }) => (
              <Form className="flex flex-col items-center !my-[1.5rem] !px-[10%]">
                <div className="grid grid-cols-2 gap-x-4 gap-y-5 w-full max-w-lg ">
                  {inquiryFormDetails.map(
                    ({ name, label, required, colSpan, types }) => (
                      <div
                        key={name || label}
                        className={`flex flex-col ${colSpan}`}
                      >
                        {label && (
                          <label
                            htmlFor={name}
                            className="text-[#151B2D] !mb-[0.5rem]"
                          >
                            {label}
                            {required && (
                              <span className="text-red-500 ml-1">*</span>
                            )}
                          </label>
                        )}
                        {types === "select" ? (
                          <div className="space-y-2">
                            <Field name={name}>
                              {({ field, form }: any) => (
                                <div className="space-y-2">
                                  <div className="border p-2 w-full border-gray-300 rounded-[10rem] text-[#151B2DB2] cursor-pointer"
                                    onClick={() => {
                                      form.setFieldValue("showEventDropdown", !form.values.showEventDropdown);
                                      form.setFieldTouched("eventType", true); // Mark as touched when opening dropdown
                                    }} >
                                    {field.value || "Select Event"}
                                  </div>

                                  {/* Dropdown list */}
                                  {form.values.showEventDropdown && (
                                    <div className="border rounded-md !mt-1 p-2 space-y-2 max-h-40 overflow-y-auto bg-white border-gray-300 cursor-pointer">
                                      {eventTypes.map((type) => (
                                        <label key={type} className="flex items-center gap-2 cursor-pointer">
                                          <input
                                            type="checkbox"
                                            name="eventType"
                                            value={type}
                                            checked={field.value === type}
                                            onChange={() => {
                                              form.setFieldValue("eventType", type);
                                              form.setFieldTouched("eventType", true); // ✅ mark as touched

                                              if (type !== "Others") {
                                                form.setFieldValue("customEventType", "");
                                                form.setFieldValue("showEventDropdown", false);
                                              }
                                            }}
                                          />
                                          {type}
                                        </label>
                                      ))}

                                      {/* If "Other" is selected, show textarea */}
                                      {field.value === "Others" && (
                                        <div className="mt-2">
                                          <Field
                                            as="textarea"
                                            name="customEventType"
                                            placeholder="Enter your event here..."
                                            className="border p-2 w-full border-gray-300 rounded-md mt-1 text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
                                          />
                                        </div>
                                      )}

                                      <button
                                        type="button"
                                        onClick={() => {
                                          form.setFieldValue("showEventDropdown", false);
                                          form.setFieldTouched("eventType", true); // ✅ ensure touched
                                        }}
                                        className="bg-blue-500 text-white px-4 py-1 rounded mt-2 cursor-pointer"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  )}

                                  {/* Error message */}
                                  {/* {getIn(form.touched, "eventType") && getIn(form.errors, "eventType") && (
                                    <ErrorMessage
                                      name="eventType"
                                      component="div"
                                      className="text-red-500"
                                    />
                                  )} */}
                                    {(!values.eventType ) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                                    {(field.value === "Others" && !values.customEventType ) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                                </div>
                              )}
                            </Field>
                          </div>
                        ) : types === "date" ? (
                          <div className="space-y-2">
                            {values.datePreference.includes("Flexible") || values.datePreference.includes("Multiple") ? (
                              // Multi Date Picker for Flexible/Multiple
                              <DatePicker
                                multiple={values.datePreference.includes("Multiple")}
                                value={values.eventDates}
                                onChange={(date: any) => {
                                  setFieldValue("eventDates", date);
                                  setFieldTouched("eventDates", true);
                                }}
                                minDate={new Date()}
                                 format="DD/MM/YYYY"
                                plugins={[<DatePanel />]}
                                placeholder="DD-MM-YYYY"
                                className="teal !w-full"
                                inputClass="border p-2 w-full border-gray-300 rounded-[10rem] text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
                              />
                            ) : (
                              // Single Date Picker for Fixed
                              <div className="relative">
                                <Field
                                  id={name}
                                  name={name}
                                  type="date"
                                  min={new Date().toISOString().split("T")[0]}
                                  onKeyDown={(e: any) => e.preventDefault()}
                                  className="border p-2 w-full border-gray-300 rounded-[10rem] mt-1 text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200 appearance-none opacity-0 absolute" // Hide the actual input but keep it functional
                                />
                                {/* Custom input that looks like a date field */}
                                <div className="border p-2 w-full border-gray-300 rounded-[10rem] mt-1 text-[#151B2DB2] bg-white">
                                  {values.eventDates && values.eventDates !== "" ? (
                                    // Show the selected date in DD-MM-YYYY format
                                    new Date(values.eventDates).toLocaleDateString('en-GB')
                                  ) : (
                                    // Show placeholder
                                    <span className="text-[#151B2DB2]">DD-MM-YYYY</span>
                                  )}
                                </div>
                                {/* Clickable overlay to trigger date picker */}
                                <div
                                  className="absolute inset-0 cursor-pointer"
                                  onClick={() => {
                                    const dateInput = document.getElementById(name) as HTMLInputElement;
                                    if (dateInput) {
                                      dateInput.showPicker();
                                    }
                                  }}
                                />
                              </div>
                            )}
                            {/* Show error only for Fixed dates when touched or submitting */}
                            {values.datePreference.includes("Fixed") &&
                              (touched.eventDates || isSubmitting) &&
                              !values.eventDates && (
                                <span className="text-red-500">Please select an event date</span>
                              )}

                            {!values.datePreference.includes("Fixed") && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                          </div>
                        ) : types === "checkbox" ? (
                          <div className="flex flex-col col-span-2">
                            <label className="text-[#151B2D] !mb-[0.5rem]">
                              Date Preference <span className="text-red-500 ml-1">*</span>
                            </label>
                            <Field name="datePreference">
                              {({ field, form }: any) => (
                                <div className="flex gap-6">
                                  {["Flexible", "Multiple", "Fixed"].map((value) => (
                                    <label key={value} className="flex items-center gap-2 cursor-pointer">
                                      <input
                                        className="cursor-pointer"
                                        type="checkbox"
                                        value={value}
                                        checked={field.value.includes(value)}
                                        onChange={() => {
                                          // Prevent unchecking if this is the only selected option
                                          if (field.value.includes(value) && field.value.length === 1) {
                                            return; // Don't allow unchecking the last option
                                          }

                                          if (field.value.includes(value)) {
                                            // If unchecking, ensure at least one option remains selected
                                            const newValue = field.value.filter((v: string) => v !== value);
                                            if (newValue.length === 0) {
                                              // If would be empty, keep the current selection
                                              return;
                                            }
                                            form.setFieldValue("datePreference", newValue);
                                            form.setFieldValue("eventDates", newValue.includes("Fixed") ? "" : []);
                                          } else {
                                            // If checking, replace the current selection
                                            form.setFieldValue("datePreference", [value]);
                                            form.setFieldValue("eventDates", value === "Fixed" ? "" : []);
                                          }

                                          form.setFieldTouched("datePreference", true);
                                        }}
                                      />
                                      {value}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </Field>
                            <ErrorMessage
                              name="datePreference"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        ) : types === "status" ? (
                          <div className="space-y-2">
                            <Field name={name}>
                              {({ field, form }: any) => (
                                <div className="space-y-2">
                                  {/* Status dropdown trigger */}
                                  <div
                                    className="border p-2 w-full border-gray-300 rounded-[10rem] text-[#151B2DB2] cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
                                    onClick={() => form.setFieldValue("showStatusDropdown", !form.values.showStatusDropdown)}
                                  >
                                    {field.value || "Select Status"}
                                  </div>

                                  {/* Dropdown list */}
                                  {form.values.showStatusDropdown && (
                                    <div className="border rounded-md !mt-1 p-2 space-y-2 max-h-40 overflow-y-auto bg-white border-gray-300 cursor-pointer">
                                      {statusOptions.map((status) => (
                                        <label key={status} className="flex items-center gap-2 cursor-pointer">
                                          <input
                                            type="checkbox"
                                            name="salesStatus"
                                            value={status}
                                            checked={field.value === status}
                                            onChange={() => {
                                              form.setFieldValue("salesStatus", status);
                                              form.setFieldTouched("salesStatus", true);
                                              form.setFieldValue("showStatusDropdown", false); // Close dropdown after selection
                                            }}
                                            className="cursor-pointer"
                                          />
                                          {status}
                                        </label>
                                      ))}

                                      {/* <button
                type="button"
                onClick={() => {
                  form.setFieldValue("showStatusDropdown", false);
                  form.setFieldTouched("status", true);
                }}
                className="bg-blue-500 text-white px-4 py-1 rounded mt-2 cursor-pointer"
              >
                Close
              </button> */}
                                    </div>
                                  )}

                                  {/* Show reason input when status is LOST */}
                                  {/* {field.value === "LOST" && (
            <div className="mt-2">
              <label htmlFor="lostReason" className="text-[#151B2D] !mb-[0.5rem]">
                Reason for Lost <span className="text-red-500 ml-1">*</span>
              </label>
              <Field
                as="textarea"
                name="lostReason"
                placeholder="Please provide reason for lost enquiry..."
                className="border p-2 w-full border-gray-300 rounded-md mt-1 text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              <ErrorMessage
                name="lostReason"
                component="div"
                className="text-red-500"
              />
            </div>
          )} */}
                                </div>
                              )}
                            </Field>
                            {getIn(touched, name) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                          </div>
                        ) : types === "textarea" ? (
                          <div className="space-y-2">
                            <Field
                              id={name}
                              name={name}
                              as="textarea"
                              placeholder={`Enter ${label}`}
                              className="border p-2 w-full border-gray-300 rounded-[0.5rem] mt-1 text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
                            />
                            {getIn(touched, name) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                          </div>
                        ) : types === "budgetRadio" ? (
                          <div className="space-y-2">
                            <Field name="budgetType">
                              {({ field, form }: any) => (
                                <div className="flex gap-6">
                                  {["Overall", "Per person"].map((value) => (
                                    <label key={value} className="flex items-center gap-2 cursor-pointer">
                                      <input
                                        type="radio"
                                        name="budgetType"
                                        value={value}
                                        checked={field.value === value}
                                        onChange={() => {
                                          form.setFieldValue("budgetType", value);
                                          form.setFieldTouched("budgetType", true);
                                        }}
                                        className="cursor-pointer"
                                      />
                                      {value}
                                    </label>
                                  ))}
                                </div>
                              )}
                            </Field>
                            {getIn(touched, name) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                          </div>
                        ) : types === "text" && name === "budget" ? (
                          <div className="space-y-1">
                            {/* Input wrapper with pound symbol */}
                            <div className="relative">
                              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                                <span className="text-gray-500">£</span>
                              </div>

                              <Field
                                id={name}
                                name={name}
                                type="number"
                                min={0}
                                placeholder={`Enter ${values.budgetType === "Per person" ? "budget per person" : "total budget"}`}
                                onKeyDown={(e: any) => {
                                  if (e.key === "-") e.preventDefault();
                                }}
                                className="border pl-7 p-2 w-full border-gray-300 rounded-[10rem] text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
                              />
                            </div>

                            {/* Error message (sits below input, doesn’t affect £ positioning) */}
                            {getIn(touched, name) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="space-y-2">
                            <Field
                              id={name}
                              name={name}
                              type={name === "numberOfGuests" ? "number" : types}
                              min={0}
                              placeholder={`Enter ${label}`}
                              onKeyDown={(e: any) => {
                                if (e.key === "-") e.preventDefault();
                              }}
                              className="border p-2 w-full border-gray-300 rounded-[10rem] mt-1 text-[#151B2DB2] focus:outline-none focus:ring-2 focus:ring-blue-200"
                            />
                            {getIn(touched, name) && getIn(errors, name) && (
                              <ErrorMessage
                                name={name}
                                component="div"
                                className="text-red-500"
                              />
                            )}
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>
                <div className="flex justify-between gap-4 w-full max-w-lg !mt-4">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="bg-primaryBlue text-white px-6 py-1 rounded cursor-pointer"
                  >
                    Back
                  </button>

                  <button
                    type="submit"
                    className="bg-primaryBlue text-white px-6 py-1 rounded cursor-pointer"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div className="col-span-1 rounded-[5px] bg-white flex justify-center">
          <div className="text-labelLightGray !px-[10%] !mt-[4rem]">
            <h1 className="text-center font-semibold text-[1.5rem] !mb-[1.5rem]">
              Contact <span className="text-primaryBlue">Us </span>
            </h1>
            <p className="!mb-[1.5rem]">
              We’d love to hear from you! Whether you have questions, need
              assistance, or want to share feedback, our team is here to help.
              Reach out via email, phone, or chat, and we’ll get back to you as
              soon as possible. Your satisfaction is important to us, and we're
              dedicated to providing exceptional support every step of the way.
            </p>
            <p className="!mb-[1.5rem]">
              Need assistance or have questions? We’re here for you! Our team is
              ready to ensure you have a great experience with us. Feel free to
              connect with us through email, phone, or social media, and we’ll
              respond promptly. Your feedback matters, and we’re committed to
              helping however we can
            </p>
            <div className="!mt-[2.5rem] text-[1.1rem] font-medium">
              <div className="flex gap-9 !mb-[1.2rem]">
                <img src={conatactImg} alt="" />
                <label>02132054205</label>
              </div>
              <div className="flex gap-9 !mb-[1.2rem]">
                <img src={mailImg} alt="" />
                <label>hello@awesomeevents.co.uk</label>
              </div>
              <div className="flex gap-9 !mb-[1.2rem]">
                <img src={linkedinImg} alt="" />
                <label>Awesome Group</label>
              </div>
            </div>
            <div className="border-1 !mt-[3rem] border-[#e3dfde] rounded-[5px]">
              <h1 className="text-center text-black !mt-[1.5rem]">Notes:</h1>
              <ul className="list-disc pl-5 !my-[1.5rem] font-semibold !ml-[3rem] text-[1.1rem]">
                <li className="!mb-[1rem]">
                  Fields marked with * are Mandatory
                </li>
                <li>
                  All fields to be a free text apart form Event Date and Event
                  type.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <CommonSnackbar
        open={snackbar.open}
        message={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        backgroundColor={snackbar.backgroundColor}
      />
    </div>
  );
};

export default InquiryForm;
